import {TextareaInputProps} from 'common/types';
import {FC} from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Label = styled.label`
  width: 100%;
  font-family: ${({theme}) => theme.fonts.teko};
`;

const Error = styled.span`
  width: 100%;
  color: ${({theme}) => theme.colors.red};
  font-size: ${({theme}) => theme.fontSize(0.65)}px;
  line-height: ${({theme}) => theme.fontSize(0.65)}px;
  margin-top: ${({theme}) => theme.spacing(0.25)}px;
`;

const Input = styled.textarea<{hasError?: boolean}>`
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  min-height: 8em;
  padding: ${({theme}) => theme.spacing(0.75)}px ${({theme}) => theme.spacing(0.75)}px;
  color: ${({theme}) => theme.colors.black};
  font-size: ${({theme}) => theme.fontSize(0.75)}px;
  line-height: ${({theme}) => theme.fontSize(0.95)}px;
  font-weight: 500;
  border: none;
  text-transform: none;
  text-decoration: none;
  border: 1px solid ${({theme, hasError}) => (hasError ? theme.colors.red : theme.colors.blue)};
  border-radius: 5px;
  transition: border 250ms ease-in-out;
`;

const TextareaInput: FC<TextareaInputProps> = ({label, hasError, error, ...props}) => {
  return (
    <Container>
      {label && <Label>{label}</Label>}
      <Input hasError={hasError} {...props} />
      {hasError && <Error>{error}</Error>}
    </Container>
  );
};

export default TextareaInput;
